import { render, staticRenderFns } from "./campo-vertical.vue?vue&type=template&id=62dc12d2&scoped=true&"
import script from "./campo-vertical.vue?vue&type=script&lang=ts&"
export * from "./campo-vertical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc12d2",
  null
  
)

export default component.exports